module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_vestland_neg.ed04b993.pdf";